// extracted by mini-css-extract-plugin
export default {"page":"PrivacyPolicy_page__pRjQv","frame":"PrivacyPolicy_frame__5iuJO"};